<template>
  <v-app-bar dense app clipped-left dark style="background-color: #10303D;">
    <v-app-bar-nav-icon
      id="buttonMenu"
      @click="$emit('changeMenu')"
    ></v-app-bar-nav-icon>
    <v-btn
      text
      id="goHome"
      @click="goHome"
      class="pb-1"
      style="height: 115%;"
      v-if="this.$vuetify.breakpoint.mdAndUp"
    >
      <img :src="logo" />
    </v-btn>
    <v-spacer></v-spacer>
    <div v-if="this.$vuetify.breakpoint.mdAndUp">
      <h5>{{ $keycloak.tokenParsed.preferred_username }}</h5>
    </div>
    <v-menu left offset-x v-if="showBadgeMensagem">
      <template v-slot:activator="{ on }">
        <v-badge
          v-model="showBadgeMensagem"
          style="margin-left: 20px; margin-right: 5px;"
          overlap
          color="primary"
        >
          <template v-slot:badge>
            <span>{{ qtMensagens }}</span>
          </template>
          <v-icon v-on="on">fas fa-envelope</v-icon>
        </v-badge>
      </template>
      <v-list two-line style="background: darkslategray;">
        <template :item="item" v-for="item in mensagensNaoLidas">
          <v-list-tile
            :name="item.idMensagem"
            v-if="showBadgeMensagem"
            :key="item.idMensagem"
            id="goMensagem"
            @click="marcarMensagemComoLidaEAbrir(item)"
          >
            <v-list-tile-action>
              <v-icon>fas fa-envelope-open-text</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.stTitulo"></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="
                  item.dhRecebida +
                    ' - ' +
                    item.stTexto.substring(0, 80) +
                    '...'
                "
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-divider v-if="showBadgeMensagem"></v-divider>

      <v-list-tile
        two-line
        style="background: darkslategray;"
        id="goHistoricoMensagens"
        to="/historicoMensagens"
      >
        <v-list-tile-action> <v-icon>fas fa-inbox</v-icon> </v-list-tile-action>
        <v-list-tile-title>Histórico de mensagens</v-list-tile-title>
      </v-list-tile>
    </v-menu>
    <v-btn text icon @click="$keycloak.logout()">
      <v-icon>fas fa-power-off</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import negative from "@/assets/MeuLote-pq-neg.png";

export default {
  data() {
    return {};
  },
  computed: {
    logo() {
      return negative;
    },
    exibeLogo() {
      if (this.$vuetify.breakpoint.mdAndUp) return true;
      return false;
    },
    showBadgeMensagem() {
      return false;
    },
    urlAPIMensagens() {
      return process.env.VUE_APP_URL_API_MENSAGENS;
    },
    // mensagensNaoLidas () {
    //   return this.$store.state.mensagensNaoLidas
    // },
    // qtMensagens () {
    //   return this.mensagensNaoLidas.length
    // },
    // showBadgeMensagem () {
    //   return this.qtMensagens >= 1
    // }
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    },
    marcarMensagemComoLidaEAbrir(mensagem) {
      this.$axios
        .post(
          this.urlAPIMensagens +
            mensagem.idMensagem +
            "/usuario/" +
            this.$keycloak.tokenParsed.sub +
            "/lida/"
        )
        .then(() => {
          this.$store.dispatch("actLoadMensagensNaoLidas");
          this.$store.dispatch("actLoadHistoricoMensagens");
          this.$router.push({
            name: "mensagem",
            params: { id: mensagem.idMensagem },
          });
        })
        .catch((error) => {
          this.changeViewState("isError", error);
        });
    },
  },
};
</script>

<style>
.v-badge--overlap .v-badge__badge {
  top: -8px !important;
  right: -13px !important;
  width: 22px !important;
  height: 22px !important;
}
</style>
